// 需要区分开发版和生产版的配置
const config = {
  development: {
    SERVER_URL: 'https://sit.pc.whhda.xyz/trace_ent_back',
    MOBILE_HOST: 'https://qwent.m.whhda.xyz',
    TOKEN_NAME: 'ENT_TRACE_H5_TOKEN_DEV'
  },
  production: {
    SERVER_URL: 'https://sit.pc.whhda.xyz/trace_ent_back',
    MOBILE_HOST: 'https://qwent.m.whhda.xyz',
    TOKEN_NAME: 'QW_ENT_TRACE_H5_TOKEN'
  }
}
// 项目名，一般用于首页及浏览器导航标签
const PROJECT_NAME = '农事记'
const TRACE_TOOLS_HOST = 'https://sit.whhda.xyz/traceTools'
const X_ADDR = '51,5111,511123'

const UPLOAD_CONFIG = {
  uploadUrl: 'https://up-z2.qiniup.com/',
  fetchUrl: 'https://cdntrace.whhda.xyz/'
}

let mapKey = 'development'
if (process.env.NODE_ENV !== mapKey) {
  mapKey = 'production'
}
const { SERVER_URL, MOBILE_HOST, TOKEN_NAME } = config[mapKey]

const COMPANY_LOCAL_TAG = `${TOKEN_NAME}_COMPANY_INFO`
const MOBILE_TRACE_DISPLAY_URL = `${MOBILE_HOST}/#/tc?c=`
const MOBILE_TRACE_DISPLAY_URL_PACK = `${MOBILE_HOST}/#/tp?c=`

export {
  TOKEN_NAME,
  COMPANY_LOCAL_TAG,
  PROJECT_NAME,
  TRACE_TOOLS_HOST,
  UPLOAD_CONFIG,
  SERVER_URL,
  MOBILE_HOST,
  MOBILE_TRACE_DISPLAY_URL,
  MOBILE_TRACE_DISPLAY_URL_PACK,
  X_ADDR
}
